import React, { useRef, useState } from 'react';
import {
  AutoComplete,
  AutoCompleteChangeEvent,
  AutoCompleteHandle
} from '@progress/kendo-react-dropdowns';

type Props = {
  data?: string[];
  value?: string;
  placeholder?: string;
  onChange: (event) => void;
};

const AutoCompleteFilter = ({
  data = [],
  value = '',
  placeholder,
  onChange
}: Props) => {
  const [stateValue, setStateValue] = useState<string>(value);
  const [filteredData, setFilteredData] = useState<string[]>(data);
  const inputRef = useRef<AutoCompleteHandle | null>(null);

  const handleInputChange = (event: AutoCompleteChangeEvent) => {
    const value = event.target.value;
    setStateValue(value);

    if (!value) {
      setFilteredData(data);
      onChange({
        value: '',
        operator: 'contains',
        syntheticEvent: event.syntheticEvent
      });
    } else {
      setFilteredData(
        data.filter((item) => item.toLowerCase().includes(value.toLowerCase()))
      );
    }
  };

  const handleSelect = (event) => {
    if ((event.nativeEvent as KeyboardEvent).code === 'Enter') {
      onChange({
        value: stateValue,
        operator: 'contains',
        syntheticEvent: event.syntheticEvent
      });
      return;
    }

    const clickedOnInvalidOption =
      event.syntheticEvent?.currentTarget?.role !== 'option';
    if (clickedOnInvalidOption) {
      return;
    }

    const value = event.target.value;
    setStateValue(value);
    if (!value) {
      onChange({
        value,
        operator: '',
        syntheticEvent: event.syntheticEvent
      });
    } else {
      onChange({
        value,
        operator: 'eq',
        syntheticEvent: event.syntheticEvent
      });
    }
  };

  return (
    <div className="k-filtercell">
      <AutoComplete
        ref={inputRef}
        className="autocomplete-filter"
        data={filteredData}
        onChange={handleInputChange}
        onClose={handleSelect}
        value={stateValue}
        placeholder={placeholder}
      />
    </div>
  );
};

export default AutoCompleteFilter;
